import useMutationApi from 'src/api/useMutationApi';

interface Body {
  userId: string;
}

interface ApiResponse {}

export function useAddUserToGroup(groupId: string) {
  return useMutationApi<Body, ApiResponse>({
    endpoint: `organization/groups/${groupId}/members`,
    method: 'POST',
  });
}
